import React, { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import "./style.css";

const ImageFadeIn = ({ src, alt, loading, srcSet, style, onClick }) => {
    const [show, setShow] = useState(false);
    const [ref, inView] = useInView({
        triggerOnce: true, // Only trigger once when the image comes into view
        threshold: 0.1, // Adjust the threshold as needed
        skip: false,
    });

    useEffect(() => {
        if (inView) {
            setTimeout(() => {
                setShow(true);
            }, 500);
        } else {
            setShow(false);
        }
    }, [inView]);

    return (
        <img
            ref={ref}
            loading={loading}
            srcSet={srcSet}
            style={style}
            onClick={(event) => onClick(event)}
            src={src}
            alt={alt}
            className={`fade-in ${show ? "show" : ""}`}
        />
    );
};

export default ImageFadeIn;
